import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "select-pop"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "tip"
};
const _hoisted_4 = {
  class: "pop-content"
};
const _hoisted_5 = {
  key: 0,
  class: "content"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "check"
};
const _hoisted_8 = {
  class: "a-cell"
};
const _hoisted_9 = {
  class: "a-cell-left"
};
const _hoisted_10 = {
  class: "place"
};
const _hoisted_11 = {
  class: "text"
};
const _hoisted_12 = {
  class: "info"
};
const _hoisted_13 = {
  class: "right"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["src"];
const _hoisted_16 = ["onClick"];
const _hoisted_17 = ["src"];
const _hoisted_18 = {
  key: 1,
  class: "empty"
};
const _hoisted_19 = ["src"];
import { computed, ref, onMounted } from 'vue';
import { showToastText } from '@/utils/common';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import constants from '@/constants';
import { useLess } from '@/models/hooks';
import { getKYCListByCustomerId, removeKYCCollection } from '@/models/api/orderConfirmApi';
export default {
  __name: 'SelectKYCPop',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    selectedKYC: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  emits: ['update:show', 'update:selectedKYC', 'handleSelectKYC'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    useLess('components/SelectAddressPop.less');
    const checkedSvg = `${constants.IMAGE_URL}assets/svg/checked.svg`;
    const {
      t
    } = useI18n();
    const router = useRouter();
    const store = useStore();
    const buttonRef = ref();
    const buttonOffsetRef = ref();
    const isLoading = ref(false);
    const kycList = ref([]);
    const distanceFromBottom = computed(() => {
      var _ref, _store$state$navigato;
      return (_ref = `${Number((_store$state$navigato = store.state.navigator.agentData) === null || _store$state$navigato === void 0 ? void 0 : _store$state$navigato.bottom)}px`) !== null && _ref !== void 0 ? _ref : '0';
    });
    const getKycList = async () => {
      try {
        var _data$kycItemList$sor, _data$kycItemList;
        isLoading.value = true;
        const {
          data
        } = await getKYCListByCustomerId();
        kycList.value = (_data$kycItemList$sor = data === null || data === void 0 ? void 0 : (_data$kycItemList = data.kycItemList) === null || _data$kycItemList === void 0 ? void 0 : _data$kycItemList.sort((a, b) => b.lastUpdatedDate - a.lastUpdatedDate)) !== null && _data$kycItemList$sor !== void 0 ? _data$kycItemList$sor : [];
      } catch (error) {
        console.error('api---error---getKYCListByCustomerId', error);
      } finally {
        isLoading.value = false;
      }
    };
    const swipeCellWidth = computed(() => {
      var _buttonRef$value, _buttonRef$value$, _buttonOffsetRef$valu, _buttonOffsetRef$valu2;
      return ((_buttonRef$value = buttonRef.value) === null || _buttonRef$value === void 0 ? void 0 : (_buttonRef$value$ = _buttonRef$value[0]) === null || _buttonRef$value$ === void 0 ? void 0 : _buttonRef$value$.clientWidth) * 2 - ((_buttonOffsetRef$valu = buttonOffsetRef.value) === null || _buttonOffsetRef$valu === void 0 ? void 0 : (_buttonOffsetRef$valu2 = _buttonOffsetRef$valu[0]) === null || _buttonOffsetRef$valu2 === void 0 ? void 0 : _buttonOffsetRef$valu2.clientWidth);
    });
    const isShowPopup = computed({
      get: () => props.show,
      set: val => {
        emit('update:show', val);
      }
    });
    const cptSelectedKYC = computed({
      get: () => props.selectedKYC,
      set: val => {
        emit('update:selectedKYC', val);
      }
    });
    const goToFillKycPage = type => {
      router.push({
        name: 'fillKYC',
        params: {
          fromType: 'spc',
          type
        }
      });
    };
    const handleClick = item => {
      cptSelectedKYC.value = item;
      emit('handleSelectKYC', item, true);
      isShowPopup.value = false;
    };
    const handleEdit = item => {
      store.commit('checkout/setFillKYC', {
        maskedId: item.maskedId,
        kycId: item.kycId,
        holderName: item.holderName,
        maskedPhoneNumber: item.maskedPhoneNumber,
        frontCitizenUploadToken: item.frontCitizenUploadToken,
        backCitizenUploadToken: item.backCitizenUploadToken
      });
      isShowPopup.value = false;
      goToFillKycPage('edit');
    };
    const handleDelete = async item => {
      try {
        isLoading.value = true;
        const {
          data
        } = await removeKYCCollection({
          kycId: item.kycId
        });
        if (data === constants.SUCCESS_STATUS_CODE) {
          showToastText(t('modules.checkout.DELETE_SUCCESSFULLY'), true);
        }
        await getKycList();
        if (item.kycId === props.selectedKYC.kycId || kycList.value.length === 0) {
          const selectedKyc = kycList.value.length > 0 ? kycList.value[0] : null;
          emit('handleSelectKYC', selectedKyc);
          cptSelectedKYC.value = selectedKyc;
        }
      } catch (error) {
        showToastText(t('modules.checkout.DELETE_FAILED'));
        console.error('api---RemoveKYCCollection---error');
      } finally {
        isLoading.value = false;
      }
    };
    const handleAdd = () => {
      isShowPopup.value = false;
      goToFillKycPage('add');
    };
    onMounted(async () => {
      getKycList();
    });
    return (_ctx, _cache) => {
      const _component_van_swipe_cell = _resolveComponent("van-swipe-cell");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_popup = _resolveComponent("van-popup");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_van_popup, {
        show: isShowPopup.value,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => isShowPopup.value = $event),
        closeable: "",
        round: "",
        position: "bottom",
        "overlay-class": "a-overlay-white",
        class: "a-select-pop",
        style: {
          height: '410px',
          width: '100%'
        }
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('modules.checkout.SELECT_KYC')), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('modules.checkout.ORDERER_AND_PAYER_SHOULD_BE_SAME')), 1), _createElementVNode("div", _hoisted_4, [kycList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kycList.value, item => {
          return _openBlock(), _createBlock(_component_van_swipe_cell, {
            class: "a-swipe-cell",
            key: item.kycId,
            "right-width": swipeCellWidth.value
          }, {
            right: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
              class: "a-button edit",
              onClick: $event => handleEdit(item)
            }, [_createElementVNode("img", {
              src: `${_unref(constants).IMAGE_URL}assets/svg/edit.svg`,
              alt: ""
            }, null, 8, _hoisted_15), _createElementVNode("span", null, _toDisplayString(_unref(t)('button.EDIT')), 1)], 8, _hoisted_14), _createElementVNode("div", {
              ref_for: true,
              ref_key: "buttonRef",
              ref: buttonRef,
              class: "a-button delete",
              onClick: $event => handleDelete(item)
            }, [_createElementVNode("img", {
              src: `${_unref(constants).IMAGE_URL}assets/svg/delete.svg`,
              alt: ""
            }, null, 8, _hoisted_17), _createElementVNode("span", null, _toDisplayString(_unref(t)('button.DELETE')), 1)], 8, _hoisted_16), _createElementVNode("div", {
              class: "buttonOffset",
              ref_for: true,
              ref_key: "buttonOffsetRef",
              ref: buttonOffsetRef
            }, null, 512)])]),
            default: _withCtx(() => {
              var _props$selectedKYC;
              return [_createElementVNode("div", {
                class: "cell-content",
                onClick: $event => handleClick(item)
              }, [_createElementVNode("div", _hoisted_7, [((_props$selectedKYC = __props.selectedKYC) === null || _props$selectedKYC === void 0 ? void 0 : _props$selectedKYC.kycId) === item.kycId ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: checkedSvg,
                alt: ""
              })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString(item.holderName), 1)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("span", null, _toDisplayString(_unref(t)('modules.checkout.ID_CARD_NUM')), 1), _createElementVNode("span", null, _toDisplayString(_unref(t)('modules.checkout.TAIL_NUMBER')) + _toDisplayString(item.maskedId), 1)])])])], 8, _hoisted_6)];
            }),
            _: 2
          }, 1032, ["right-width"]);
        }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("img", {
          src: `${_unref(constants).IMAGE_URL}assets/image/Emptylist_KYC.png`,
          alt: ""
        }, null, 8, _hoisted_19), _createElementVNode("div", null, _toDisplayString(_unref(t)('modules.checkout.NO_KYC')), 1)]))]), _createElementVNode("div", {
          class: "btn-box",
          style: _normalizeStyle({
            paddingBottom: distanceFromBottom.value
          })
        }, [_createVNode(_component_van_button, {
          round: "",
          color: "#EB1745",
          block: "",
          onClick: handleAdd
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('modules.checkout.ADD_KYC_INFO')), 1)]),
          _: 1
        })], 4)])), [[_directive_loading, isLoading.value]])]),
        _: 1
      }, 8, ["show"]);
    };
  }
};